<template>
    <HeadComponent :element/>

    <section class="h-full md:px-4 my-4">
        <section class="flex flex-col lg:flex-row">
            <!-- left -->
            <div class="flex-1">
                <!-- video -->
                <div class="bg-main-bright shadow-element rounded-[10px] mb-6">
                    <div class="relative pb-9/16 rounded-xl overflow-hidden">
                        <iframe class="absolute w-full h-full"
                                :src="element.url"
                                frameborder="0"></iframe>
                        <!-- admin controls -->
                        <AdminPanel class="opacity-90 absolute z-20"
                                    :model="'Content'"
                                    :element="element"/>
                    </div>

                    <div class="pt-2 sm:pt-3 pb-5 px-2 sm:px-4">
                        <div class="flex flex-wrap mb-2.5">
                            <TagHashed class="mr-5 last:mr-0"
                                       :tag="tag"
                                       :filter="filtered.filters.tag"
                                       v-for="tag in tagsList"
                                       :key="tag"/>
                        </div>

                        <h3 class="mb-4 text-lg md:text-2xl font-semibold text-main-primary">{{ element.title }}</h3>

                        <div class="flex flex-col sm:flex-row sm:flex-wrap sm:items-center justify-between">
                            <p class="text-main-secondary text-sm mb-5 sm:mb-0">
                                {{ created(element.published_at) }}</p>
                            <ContentShareComponent :element="element"/>
                        </div>
                    </div>
                </div>

                <ContentDescription :element
                                    :filtered
                                    :schema/>

                <!-- <comments :input="element" /> -->

                <BannerManager />
            </div>

            <!-- right -->
            <div id="sidebar"
                 :class="top_offset"
                 class="sidebar hidden lg:block w-[274px] ml-4 pb-16">
                <div class="sidebar__inner">
                    <div class="flex flex-col">
                        <div class="article_side overflow-y-auto "
                             :style="tag_height">
                            <h3 class="text-sm font-semibold text-main-primary mb-3">Мы рекомендуем</h3>

                            <div class="flex flex-col gap-6">
                                <ContentCard class="mb-5"
                                             :mini="true"
                                             :element="card"
                                             :key="i"
                                             v-for="(card, i) in contents.data"
                                             style="height: auto;"/>
                            </div>

                            <AdsBanner />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </section>

</template>
<script setup>
import HeadComponent from '@/shared/HeadComponent.vue';
import AdminPanel from '@/shared/contentBlock_AdminPanel.vue';
import LandLayout from '@/Layouts/LandLayout.vue';
import TagHashed from '@/Pages/Content/Components/TagHashed.vue';
import ContentShareComponent from '@/Pages/Videos/Components/ContentShareComponent.vue';
import ContentDescription from '@/Pages/Videos/Components/ContentDescription.vue';
import BannerManager from '@/shared/Banners/BannerManager.vue';

import {created} from '@/Pages/Vacancies/Composables/useVacancyCommon.js';
import {top_offset} from '@/shared/Banners/Composables/useBanners.js';
import AdsBanner from '@/shared/Banners/AdsBanner.vue';
import ContentCard from '@/Pages/Articles/Components/ContentCard.vue';
import {onMounted, ref} from 'vue';

defineOptions({layout: LandLayout});
const props = defineProps(['element', 'contents', 'tags', 'filtered', 'comments', 'text', 'schema']);

let tag_height = ref('height:900px;');
onMounted(() => {
    tag_height.value = 'height:' + (window.innerHeight -150) +'px;';
});

let tagsList = props.element.tags ? props.element.tags.slice(0, 5) : null;
</script>
